 document.addEventListener('DOMContentLoaded', function() {
    var switcherToggle = document.getElementById('custom-language-switcher-toggle');
    var switcherList = document.getElementById('custom-language-switcher-list');

    function toggleSwitcherList() {
      switcherList.classList.toggle('custom-language-switcher__list--visible');
    }

    switcherToggle.addEventListener('click', function(event) {
      event.preventDefault();
      toggleSwitcherList();
    });

    document.addEventListener('click', function(event) {
      var target = event.target;
      var isSwitcherToggle = target.closest('#custom-language-switcher-toggle');
      var isSwitcherList = target.closest('#custom-language-switcher-list');

      if (!isSwitcherToggle && !isSwitcherList) {
        switcherList.classList.remove('custom-language-switcher__list--visible');
      }
    });

    var languageLinks = document.querySelectorAll('.custom-language-switcher__link');
    languageLinks.forEach(function(link) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        var localeCode = this.getAttribute('data-locale-code');
        var formInput = document.querySelector('[data-localization-input]');
        formInput.value = localeCode;
        document.querySelector('[data-localization-form]').submit();
      });
    });
  });